import * as React from 'react'

type Props = {
  fieldName?: string
}

export function ScrollToErrorMarker(props: Props) {
  const { fieldName = 'missing' } = props
  return <span data-scroll={fieldName} />
}
